<template>
  <div>
    <div v-show="hasError">
      <div
        class="d-flex errorMessage align-items-center border border-1 border-danger"
        style="padding-top: 3px"
      >
        <label class="ps-3">入力内容に誤りがあります。</label>
        <img src="../assets/注意マーク（大）.png" alt="" />
        <label>マークをご確認いただき、再度入力をお願いいたします。</label>
      </div>
    </div>
    <div class="alertMessage">{{ alertMessage }}</div>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessageArea',
  props: {
    alertMessage: String,
    hasError: Boolean
  }
}
</script>

<style scoped lang="scss">
.alertMessage {
  color: rgb(198, 25, 6);
}
.errorMessage {
  color: rgb(198, 25, 6);
  font-weight: bold;
  background-color: rgb(255, 220, 221);
}
</style>
